"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementComponent = void 0;
var Settlement_1 = require("./Settlement");
Object.defineProperty(exports, "SettlementComponent", { enumerable: true, get: function () { return Settlement_1.SettlementComponent; } });
